import { makeAutoObservable } from "mobx";

export class ThemeStorage {
    THEME_KEY = 'backoffice-theme';
    
    constructor(storage) {
        this._storage = storage;
        this._currentTheme = this._storage.get(this.THEME_KEY) || 'dark';
        makeAutoObservable(this);
    }

    getCurrentTheme() {
        this._currentTheme = this._storage.get(this.THEME_KEY) || 'dark';
        return this._currentTheme;
    }

    setTheme(themeName) {
        this._currentTheme = themeName;
        this._storage.add(this.THEME_KEY, themeName);
    }

    toggleTheme() {
        const newTheme = this._currentTheme === 'dark' ? 'light' : 'dark';
        this.setTheme(newTheme);
        return newTheme;
    }

    isDarkTheme() {
        return this.getCurrentTheme() === 'dark';
    }

    isLightTheme() {
        return this.getCurrentTheme() === 'light';
    }
}
